import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getArchivedEmployees } from "src/redux/api/_hr.api";
import { Employee } from "src/redux/types/_employee.type";

export interface Filters {
  page: number;
  pagesize: number;
  name: string;
  employee_code: string;
}

export const archivedKeys = ({
  all: ["hr-archived-emp"] as const,
  list: (filter: Filters) => [...archivedKeys.all, 'list', filter] as const
});

export const useFetchArchives = (filter: Filters) => {
  return useQuery<Employee[]>({
    queryKey: archivedKeys.list(filter),
    queryFn: () => getArchivedEmployees(filter),
    placeholderData: keepPreviousData,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};
